import type { QueryClient } from '@tanstack/vue-query';

const RESULT_QUERY_KEYS = [
    ['account-devices'],
    ['account-device'],
    ['account-geofences'],
    ['account-geofence'],
    ['account-shipments'],
    ['v2', 'account-shipment'],
    ['account-exceptions'],
    ['account-exception-metrics'],
    ['account-shipment-exceptions'],
    ['account-place-types'],
];

export default (queryClient: QueryClient) => {
    RESULT_QUERY_KEYS.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));
};
